import React, { useState } from "react";
import {
  MDBModal,
  MDBModalHeader,
  MDBModalBody,
  MDBListGroupItem,
  MDBListGroup,
  MDBBtn,
  MDBBox,
  MDBBtnGroup,
} from "mdbreact";

import Loading from "../ui-components/loading";

import { assignUserToBrand } from "api/users/addUserToBrand";
import addNotification from "helpers/notify";
import { choseToggle } from "helpers/toggleIfLoading";
import { removeUserFromBrand } from "api/users/removeUserFromBrand";

import {
  addUserToBrand as addUserToBrandRedux,
  removeUserFromBrand as removeUserFromBrandRedux,
} from "actions/user";
import {
  companyAdminAddUserToBrand,
  companyAdminRemoveUserFromBrand,
} from "actions/company-admin";
import { useDispatch, useSelector } from "react-redux";
import { useSearch } from "../../hooks/useSearch";
import { useHttp } from "../../hooks/useHttp";
import { Maybe } from "../../helpers/maybeFunctor";

import "./members-modal.scss";
import { superAdminAddUserToBrand, superAdminRemoveUserFromBrand } from "actions/super-admin";

const MembersModalAdmin = (props) => {
  const { brandListToEdit } = props;

  const usersRedux = useSelector((s) => s.superAdmin.all_users);
  const brandsRedux = useSelector((s) => s.superAdmin.company_brands);
  const emailRedux = useSelector((s) => s.user.userInfo.email);

  const userBrandsRedux = useSelector((s) => s.user.brands);
  const usersPARedux = useSelector((s) => s.user.users);

  const dispatch = useDispatch();
  const search = useSearch();

  const [searchValue, setSearchValue] = useState("");
  const [isAddPage, setIsAddPage] = useState(true);
  const [chosenUserForDelete, setChosenUserForDelete] = useState(null);
  const [chosenUserForAdd, setChosenUserForAdd] = useState(null);
  const [btn, setBtn] = useState("Pending");

  const toggle = () => {
    props.toggle();
    setChosenUserForDelete(null);
    setChosenUserForAdd(null);
  };

  const {
    loading: assignUserToBrandAPILoading,
    request: assignUserToBrandAPI,
  } = useHttp({
    requestCallback: assignUserToBrand,
    onLoad: (res) => {
      dispatch(superAdminAddUserToBrand({ user: chosenUserForAdd, brandId: brandListToEdit }));
      const canAssignToPA =
        userBrandsRedux &&
        userBrandsRedux
          .map((brand) => brand._id)
          ?.includes(chosenUserForAdd) &&
        usersPARedux &&
        usersPARedux.map((user) => user._id)?.includes(brandListToEdit);
      if (canAssignToPA) {
        dispatch(addUserToBrandRedux(chosenUserForAdd, brandListToEdit));
      }
      setChosenUserForAdd(null);
      console.log(res);
      addNotification(
        "User was successfully added to this brand!",
        "success"
      );
    },
    onError: (res) => {
      setChosenUserForAdd(null);
      addNotification("Something went wrong, please contact support", "danger");
      console.log(res);
    },
  });

  const addUserToBrand = () => {
    if (!chosenUserForAdd) {
      addNotification(
        "Choose the user you want to add to this brand",
        "default"
      );
    } else {
      return assignUserToBrandAPI({
        brand_id: brandListToEdit,
        user_id: chosenUserForAdd,
      });
    }
  };

  const {
    loading: deleteUserFromBrandLoading,
    request: removeUserFromBrandAPI,
  } = useHttp({
    requestCallback: removeUserFromBrand,
    onLoad: (res) => {
      const canAssignToPA =
        userBrandsRedux &&
        userBrandsRedux
          .map((brand) => brand._id)
          ?.includes(chosenUserForDelete) &&
        usersPARedux &&
        usersPARedux.map((user) => user._id).includes(brandListToEdit);
      if (canAssignToPA) {
        dispatch(
          removeUserFromBrandRedux(chosenUserForDelete, brandListToEdit)
        );
      }
      dispatch(
        superAdminRemoveUserFromBrand({ user: chosenUserForDelete, brandId: brandListToEdit })
      );
      setChosenUserForDelete(null);
      console.log(res);
      addNotification(
        "User was successfully removed from this brand",
        "success"
      );
    },
    onError: (res) => {
      console.log(res);
      addNotification("Something went wrong, please contact support", "danger");
    },
  });

  const deleteUserToBrand = () => {
    if (!chosenUserForDelete) {
      addNotification(
        "Choose the user you want to delete from this brand",
        "default"
      );
    } else {
      return removeUserFromBrandAPI({
        brand_id: brandListToEdit,
        user_id: chosenUserForDelete,
      });
    }
  };

  const brandListToEditUsers = Maybe.of(brandsRedux)
    .map((brandsRedux) =>
      brandsRedux.find((brandItem) => brandItem._id === brandListToEdit)
    )
    .map((brand) => brand.users).value;

  const usersAbleToAdd = Maybe.of(usersRedux)
    .map((users) => {
      if (brandListToEditUsers) {
        return users
          .filter((user) => !brandListToEditUsers?.includes(user._id))
          .filter((user) => user.email !== emailRedux);
      } else {
        return null;
      }
    })
    .map((filteredUsers) => {
      return search(filteredUsers, "email", searchValue);
    })
    .map((searchedUsers) => {
      return searchedUsers.map((user) => {
        const { name, lastName, email, _id } = user;
        return (
          <MDBListGroupItem
            key={_id}
            className="cursor-pointer p-2"
            onClick={() => setChosenUserForAdd(_id)}
            active={chosenUserForAdd === _id}
          >
            <div className="font-size-2">
              Name : {name} {lastName}
            </div>
            <span className="font-size-1">Email : {email}</span>
          </MDBListGroupItem>
        );
      });
    }).value;

  const usersAbleToDelete = Maybe.of(usersRedux)
    .map((users) => {
      if (brandListToEdit && brandListToEditUsers) {
        return users
          .filter((user) => brandListToEditUsers?.includes(user._id))
          .filter((user) => user.email !== emailRedux);
      } else {
        return null;
      }
    })
    .map((filteredUsers) => {
      return search(filteredUsers, "email", searchValue);
    })
    .map((searchedUsers) => {
      return searchedUsers.map((user) => {
        const { name, lastName, email, _id } = user;
        return (
          <MDBListGroupItem
            key={_id}
            className="cursor-pointer p-2"
            onClick={() => setChosenUserForDelete(_id)}
            active={chosenUserForDelete === _id}
          >
            <div className="font-size-2">
              Name : {name} {lastName}
            </div>
            <span className="font-size-1">Email : {email}</span>
          </MDBListGroupItem>
        );
      });
    }).value;

  const loading = deleteUserFromBrandLoading || assignUserToBrandAPILoading;

  return (
    <MDBModal
      toggle={choseToggle(loading, toggle)}
      isOpen={props.open}
      centered
    >
      <MDBModalHeader
        toggle={choseToggle(loading, toggle)}
        className="d-flex mb-0 pb-2"
      >
        Brand members
      </MDBModalHeader>
      <MDBModalBody className="pt-1">
        <div className="d-flex align-items-center w-75 mb-3">
          <MDBBtn
            size="sm"
            color=""
            className={
              btn === "Pending"
                ? "sharePending-button active-toggle"
                : "sharePending-button"
            }
            onClick={() => {
              setIsAddPage(true);
              setBtn("Pending")
            }
            }
          >
            Add user
          </MDBBtn>
          <MDBBtn
            size="sm"
            color=""
            className={
              btn === "Shared"
                ? "sharePending-button active-toggle"
                : "sharePending-button"
            }
            onClick={() => {
              setIsAddPage(false);
              setBtn("Shared");
            }}
          >
            Delete user
          </MDBBtn>
        </div>
        {isAddPage ? (
          <>
            <h6 className="mt-2 text-status">Add user menu</h6>
            <div className="form-group mb-2">
              <input
                type="text"
                className="shared-input-search"
                placeholder="Search by email.."
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />
            </div>
            <MDBListGroup className="member-ul">{usersAbleToAdd}</MDBListGroup>
            <div className="d-flex flex-center py-2">
            {loading ? <div className="d-flex flex-center py-2 spinner-box">
                 <Loading color="black" text="Loading..."  /> 
            </div>: null}
            </div>
            <MDBBox className="d-flex justify-content-end">
              <MDBBtn
                size="sm"
                color=""
                className="bg-bid border-bid text-white mdb-btn"
                onClick={addUserToBrand}
                disabled={loading}
              >
                <i className="fa fa-plus mr-2"></i> Add this user
              </MDBBtn>
            </MDBBox>
          </>
        ) : (
          <>
            <h6 className="mt-2 text-status">Delete user menu</h6>
            <div className="form-group mb-2">
              <input
                type="text"
                className="shared-input-search"
                placeholder="Search by email.."
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />
            </div>
            <MDBListGroup className="member-ul">
              {usersAbleToDelete}
            </MDBListGroup>
            <div className="d-flex flex-center py-2">
            {loading ? <div className="d-flex flex-center py-2 spinner-box">
                 <Loading color="black" text="Loading..."  /> 
            </div>: null}
            </div>
            <MDBBox className="d-flex justify-content-end">
              <MDBBtn
                size="sm"
                color=""
                className="bg-bid border-bid text-white mdb-btn"
                onClick={deleteUserToBrand}
                disabled={loading}
              >
                <i className="fa fa-trash mr-2"></i> Remove this user
              </MDBBtn>
            </MDBBox>
          </>
        )}
      </MDBModalBody>
    </MDBModal>
  );
};

export default MembersModalAdmin;
